(() => {
  'use strict';

  /*
   * ==================================================
   * SANSEVIERIA CHECKOUT ANALYTICS OBSERVER
   * ==================================================
   *
   * SAFETY:
   *
   * - Does NOT prevent clicks
   * - Does NOT prevent form submits
   * - Does NOT change cart
   * - Does NOT POST to cart
   * - Does NOT change quantity
   * - Does NOT change prices
   * - Does NOT change discounts
   * - Does NOT alter Razorpay
   * - Does NOT redirect
   *
   * It DOES:
   *
   * 1. Observe checkout attempts
   * 2. Publish sansevieria:checkout_intent
   * 3. READ ONLY GET /cart.js
   * 4. Build exact current Shopify cart
   * 5. Send GA4 begin_checkout
   * 6. Send Meta InitiateCheckout
   * 7. Publish sansevieria:checkout_cart_snapshot
   *
   * Razorpay does NOT wait for this code.
   */


  /*
   * ==================================================
   * LOAD GUARD
   * ==================================================
   */

  if (
    window.__svAnalyticsObserverLoaded
  ) {
    return;
  }

  window.__svAnalyticsObserverLoaded =
    true;


  /*
   * ==================================================
   * SHOPIFY CUSTOM EVENTS
   * ==================================================
   */

  const CHECKOUT_INTENT_EVENT =
    'sansevieria:checkout_intent';

  const CART_SNAPSHOT_EVENT =
    'sansevieria:checkout_cart_snapshot';


  /*
   * ==================================================
   * GA4
   * ==================================================
   */

  const GA4_MEASUREMENT_ID =
    'G-F1X8DWKKJM';

  const GA4_CHECKOUT_EVENT =
    'begin_checkout';


  /*
   * ==================================================
   * META
   * ==================================================
   *
   * Razorpay:
   *
   * Facebook Ads
   * → Checkout initiated
   *
   * MUST remain DISABLED.
   */

  const META_PIXEL_ID =
    '1499237654913221';

  const META_CHECKOUT_EVENT =
    'InitiateCheckout';

  /* Production storefront: keep verbose analytics diagnostics disabled. */
  const DEBUG = false;


  /*
   * ==================================================
   * STATE
   * ==================================================
   */

  let pendingBuyNowSource = '';

  let lastSignature = '';

  let lastPublishedAt = 0;


  /*
   * ==================================================
   * SHOPIFY CART URL
   * ==================================================
   */

  let shopifyRoot = '/';

  if (
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
  ) {

    shopifyRoot =
      window.Shopify.routes.root;
  }

  const CART_URL =
    shopifyRoot + 'cart.js';


  /*
   * ==================================================
   * LOGGER
   * ==================================================
   */

  function log() {

    if (!DEBUG) {
      return;
    }

    try {

      var args =
        Array.prototype.slice.call(
          arguments
        );

      args.unshift(
        '[SV Analytics Observer]'
      );

      console.log.apply(
        console,
        args
      );

    } catch (error) {
      /*
       * Logging cannot affect checkout.
       */
    }
  }


  /*
   * ==================================================
   * CHECKOUT SOURCE
   * ==================================================
   */

  function getCheckoutSource(
    element
  ) {

    if (
      !(element instanceof Element)
    ) {

      if (pendingBuyNowSource) {
        return pendingBuyNowSource;
      }

      return 'unknown';
    }


    if (
      element.closest(
        '.sv-drawer__checkout'
      )
    ) {

      return 'cart_drawer';
    }


    if (
      element.closest(
        '.cart__checkout-button'
      )
    ) {

      return 'cart_page';
    }


    if (
      element.closest(
        '#sv-magic-checkout-form'
      )
    ) {

      if (pendingBuyNowSource) {
        return pendingBuyNowSource;
      }

      return 'magic_checkout_form';
    }


    if (pendingBuyNowSource) {
      return pendingBuyNowSource;
    }


    return 'checkout';
  }


  /*
   * ==================================================
   * SHOPIFY ANALYTICS PUBLISH
   * ==================================================
   */

  function publishShopifyEvent(
    eventName,
    payload
  ) {

    try {

      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify
          .analytics
          .publish ===
          'function'
      ) {

        window.Shopify
          .analytics
          .publish(
            eventName,
            payload
          );

        return true;
      }


      log(
        'Shopify analytics unavailable',
        eventName,
        payload
      );


    } catch (error) {

      log(
        'Shopify publish error ignored',
        eventName,
        error
      );
    }


    return false;
  }


  /*
   * ==================================================
   * NORMALIZE CART ITEM
   * ==================================================
   */

  function normalizeCartItem(
    item
  ) {

    try {

      var productId = '';

      var variantId = '';

      var sku = '';

      var quantity = 0;

      var productName = '';

      var variantName = '';


      if (
        item &&
        item.product_id
      ) {

        productId =
          String(
            item.product_id
          );
      }


      if (
        item &&
        item.variant_id
      ) {

        variantId =
          String(
            item.variant_id
          );

      } else if (
        item &&
        item.id
      ) {

        variantId =
          String(
            item.id
          );
      }


      if (
        item &&
        item.sku
      ) {

        sku =
          String(
            item.sku
          );
      }


      if (
        item &&
        item.quantity
      ) {

        quantity =
          Number(
            item.quantity
          );
      }


      if (
        !isFinite(quantity) ||
        quantity < 0
      ) {

        quantity = 0;
      }


      if (
        item &&
        item.product_title
      ) {

        productName =
          String(
            item.product_title
          );

      } else if (
        item &&
        item.title
      ) {

        productName =
          String(
            item.title
          );
      }


      if (
        item &&
        item.variant_title &&
        item.variant_title !==
          'Default Title'
      ) {

        variantName =
          String(
            item.variant_title
          );
      }


      var priceInCents = 0;


      if (
        item &&
        item.final_price
      ) {

        priceInCents =
          Number(
            item.final_price
          );

      } else if (
        item &&
        item.discounted_price
      ) {

        priceInCents =
          Number(
            item.discounted_price
          );

      } else if (
        item &&
        item.price
      ) {

        priceInCents =
          Number(
            item.price
          );
      }


      if (
        !isFinite(
          priceInCents
        )
      ) {

        priceInCents = 0;
      }


      var linePriceInCents = 0;


      if (
        item &&
        item.final_line_price
      ) {

        linePriceInCents =
          Number(
            item.final_line_price
          );

      } else if (
        item &&
        item.line_price
      ) {

        linePriceInCents =
          Number(
            item.line_price
          );
      }


      if (
        !isFinite(
          linePriceInCents
        )
      ) {

        linePriceInCents = 0;
      }


      /*
       * Canonical GA4 item ID
       */

      var gaItemId = '';


      if (
        productId &&
        variantId
      ) {

        gaItemId =
          'shopify_ZZ_' +
          productId +
          '_' +
          variantId;

      } else if (
        variantId
      ) {

        gaItemId =
          variantId;

      } else {

        gaItemId =
          productId;
      }


      return {

        item_id:
          gaItemId,

        item_name:
          productName,

        item_variant:
          variantName,

        item_sku:
          sku,

        product_id:
          productId,

        variant_id:
          variantId,

        /*
         * Meta uses Shopify Variant ID.
         */

        meta_content_id:
          variantId,

        price:
          Number(
            (
              priceInCents /
              100
            ).toFixed(2)
          ),

        line_value:
          Number(
            (
              linePriceInCents /
              100
            ).toFixed(2)
          ),

        quantity:
          quantity
      };


    } catch (error) {

      log(
        'Item normalization error ignored',
        error
      );

      return null;
    }
  }


  /*
   * ==================================================
   * GA4 BEGIN_CHECKOUT
   * ==================================================
   */

  function sendGa4BeginCheckout(
    payload
  ) {

    try {

      if (
        typeof window.gtag !==
          'function'
      ) {

        log(
          'GA4 gtag unavailable - begin_checkout skipped'
        );

        return;
      }


      if (
        !payload ||
        !Array.isArray(
          payload.items
        )
      ) {

        log(
          'GA4 begin_checkout skipped - invalid cart'
        );

        return;
      }


      if (
        payload.items.length === 0
      ) {

        log(
          'GA4 begin_checkout skipped - empty cart'
        );

        return;
      }


      var gaItems = [];


      payload.items.forEach(
        function(item) {

          gaItems.push({

            item_id:
              item.item_id ||
              '',

            item_name:
              item.item_name ||
              '',

            item_variant:
              item.item_variant ||
              '',

            item_sku:
              item.item_sku ||
              '',

            price:
              Number(
                item.price ||
                0
              ),

            quantity:
              Number(
                item.quantity ||
                0
              )
          });
        }
      );


      window.gtag(
        'event',
        GA4_CHECKOUT_EVENT,
        {

          send_to:
            GA4_MEASUREMENT_ID,

          currency:
            payload.currency ||
            'INR',

          value:
            Number(
              payload.value ||
              0
            ),

          items:
            gaItems,

          checkout_source:
            payload.source ||
            'unknown'
        }
      );


      log(
        'GA4 BEGIN_CHECKOUT SENT',
        {

          event:
            GA4_CHECKOUT_EVENT,

          send_to:
            GA4_MEASUREMENT_ID,

          currency:
            payload.currency ||
            'INR',

          value:
            Number(
              payload.value ||
              0
            ),

          source:
            payload.source ||
            'unknown',

          items:
            gaItems
        }
      );


    } catch (error) {

      log(
        'GA4 begin_checkout error ignored',
        error
      );
    }
  }


  /*
   * ==================================================
   * META INITIATECHECKOUT
   * ==================================================
   *
   * Uses the existing Meta Pixel.
   *
   * Does NOT load another Meta Pixel.
   *
   * Explicitly targets:
   * 1499237654913221
   */

  function sendMetaInitiateCheckout(
    payload
  ) {

    try {

      if (
        typeof window.fbq !==
          'function'
      ) {

        log(
          'Meta fbq unavailable - InitiateCheckout skipped'
        );

        return;
      }


      if (
        !payload ||
        !Array.isArray(
          payload.items
        )
      ) {

        log(
          'Meta InitiateCheckout skipped - invalid cart'
        );

        return;
      }


      if (
        payload.items.length === 0
      ) {

        log(
          'Meta InitiateCheckout skipped - empty cart'
        );

        return;
      }


      var contentIds = [];

      var contents = [];

      var numItems = 0;


      payload.items.forEach(
        function(item) {

          var metaId =
            item.meta_content_id ||
            item.variant_id ||
            '';


          if (!metaId) {
            return;
          }


          var quantity =
            Number(
              item.quantity ||
              0
            );


          var price =
            Number(
              item.price ||
              0
            );


          contentIds.push(
            String(
              metaId
            )
          );


          contents.push({

            id:
              String(
                metaId
              ),

            quantity:
              quantity,

            item_price:
              price
          });


          numItems +=
            quantity;
        }
      );


      if (
        contentIds.length === 0
      ) {

        log(
          'Meta InitiateCheckout skipped - no Variant IDs'
        );

        return;
      }


      /*
       * Standard Meta ecommerce event.
       *
       * trackSingle explicitly targets
       * only our existing Pixel ID.
       */

      window.fbq(
        'trackSingle',
        META_PIXEL_ID,
        META_CHECKOUT_EVENT,
        {

          content_ids:
            contentIds,

          content_type:
            'product',

          currency:
            payload.currency ||
            'INR',

          value:
            Number(
              payload.value ||
              0
            ),

          num_items:
            numItems,

          contents:
            contents,

          checkout_source:
            payload.source ||
            'unknown'
        }
      );


      log(
        'META INITIATECHECKOUT SENT',
        {

          event:
            META_CHECKOUT_EVENT,

          pixel_id:
            META_PIXEL_ID,

          currency:
            payload.currency ||
            'INR',

          value:
            Number(
              payload.value ||
              0
            ),

          num_items:
            numItems,

          content_ids:
            contentIds,

          contents:
            contents,

          source:
            payload.source ||
            'unknown'
        }
      );


    } catch (error) {

      /*
       * FAIL OPEN
       */

      log(
        'Meta InitiateCheckout error ignored',
        error
      );
    }
  }


  /*
   * ==================================================
   * READ EXACT SHOPIFY CART
   * ==================================================
   *
   * GET ONLY.
   *
   * Never calls:
   *
   * /cart/add.js
   * /cart/change.js
   * /cart/update.js
   */

  function readExactCart(
    source,
    trigger
  ) {

    try {

      fetch(
        CART_URL,
        {

          method:
            'GET',

          credentials:
            'same-origin',

          headers: {

            Accept:
              'application/json'
          }
        }
      )


        .then(
          function(response) {

            if (
              !response.ok
            ) {

              throw new Error(
                'Cart read failed: ' +
                response.status
              );
            }


            return response.json();
          }
        )


        .then(
          function(cart) {

            var items = [];


            if (
              cart &&
              Array.isArray(
                cart.items
              )
            ) {

              cart.items.forEach(
                function(item) {

                  var normalized =
                    normalizeCartItem(
                      item
                    );


                  if (normalized) {

                    items.push(
                      normalized
                    );
                  }
                }
              );
            }


            var currency =
              'INR';


            if (
              cart &&
              cart.currency
            ) {

              currency =
                String(
                  cart.currency
                );
            }


            var totalPrice = 0;


            if (
              cart &&
              cart.total_price
            ) {

              totalPrice =
                Number(
                  cart.total_price
                );
            }


            if (
              !isFinite(
                totalPrice
              )
            ) {

              totalPrice = 0;
            }


            var subtotalPrice = 0;


            if (
              cart &&
              cart.items_subtotal_price
            ) {

              subtotalPrice =
                Number(
                  cart.items_subtotal_price
                );
            }


            if (
              !isFinite(
                subtotalPrice
              )
            ) {

              subtotalPrice = 0;
            }


            var itemCount = 0;


            if (
              cart &&
              cart.item_count
            ) {

              itemCount =
                Number(
                  cart.item_count
                );
            }


            if (
              !isFinite(
                itemCount
              )
            ) {

              itemCount = 0;
            }


            /*
             * Exact current cart payload
             */

            var payload = {

              source:
                source ||
                'unknown',

              trigger:
                trigger ||
                'unknown',

              page_path:
                window.location
                  .pathname,

              page_url:
                window.location
                  .href,

              timestamp:
                new Date()
                  .toISOString(),

              currency:
                currency,

              value:
                Number(
                  (
                    totalPrice /
                    100
                  ).toFixed(2)
                ),

              subtotal:
                Number(
                  (
                    subtotalPrice /
                    100
                  ).toFixed(2)
                ),

              item_count:
                itemCount,

              items:
                items
            };


            /*
             * GA4
             */

            sendGa4BeginCheckout(
              payload
            );


            /*
             * META
             */

            sendMetaInitiateCheckout(
              payload
            );


            /*
             * SHOPIFY CUSTOMER EVENT
             */

            publishShopifyEvent(
              CART_SNAPSHOT_EVENT,
              payload
            );


            /*
             * DEBUG
             */

            log(
              'CART SNAPSHOT',
              payload
            );


            if (DEBUG) {
              log(
                'CART SNAPSHOT JSON',
                JSON.stringify(
                  payload,
                  null,
                  2
                )
              );
            }

          }
        )


        .catch(
          function(error) {

            log(
              'Cart read error ignored',
              error
            );
          }
        );


    } catch (error) {

      log(
        'Cart snapshot error ignored',
        error
      );
    }
  }


  /*
   * ==================================================
   * CHECKOUT INTENT
   * ==================================================
   */

  function publishCheckoutIntent(
    source,
    trigger
  ) {

    var now =
      Date.now();


    /*
     * Prevent click + submit
     * from sending twice.
     */

    var signature = [
      source ||
        'unknown',
      window.location.pathname
    ].join('|');


    if (
      signature ===
        lastSignature &&
      now -
        lastPublishedAt <
        1500
    ) {

      return;
    }


    lastSignature =
      signature;

    lastPublishedAt =
      now;


    var intentPayload = {

      source:
        source ||
        'unknown',

      page_path:
        window.location
          .pathname,

      page_url:
        window.location
          .href,

      trigger:
        trigger ||
        'unknown',

      timestamp:
        new Date()
          .toISOString()
    };


    var published =
      publishShopifyEvent(
        CHECKOUT_INTENT_EVENT,
        intentPayload
      );


    if (published) {

      log(
        'Published',
        CHECKOUT_INTENT_EVENT,
        intentPayload
      );
    }


    /*
     * Async read only.
     *
     * Razorpay continues independently.
     */

    readExactCart(
      source,
      trigger
    );


    window.setTimeout(
      function() {

        pendingBuyNowSource =
          '';

      },
      2000
    );
  }


  /*
   * ==================================================
   * CLICK OBSERVER
   * ==================================================
   */

  document.addEventListener(
    'click',

    function(event) {

      try {

        var target = null;


        if (
          event.target instanceof
            Element
        ) {

          target =
            event.target;
        }


        if (!target) {
          return;
        }


        /*
         * Product Buy Now
         */

        if (
          target.closest(
            '.custom-buy-now-button'
          )
        ) {

          pendingBuyNowSource =
            'product_buy_now';


          log(
            'Buy Now intent observed'
          );


          return;
        }


        /*
         * Mobile Buy Now
         */

        if (
          target.closest(
            '[data-mw-sticky-buy-now]'
          )
        ) {

          pendingBuyNowSource =
            'mobile_sticky_buy_now';


          log(
            'Mobile Buy Now intent observed'
          );


          return;
        }


        /*
         * Checkout
         */

        var checkout =
          target.closest(
            [
              '[name="checkout"]',
              '.sv-drawer__checkout',
              '.cart__checkout-button'
            ].join(',')
          );


        if (!checkout) {
          return;
        }


        publishCheckoutIntent(
          getCheckoutSource(
            checkout
          ),
          'click'
        );


      } catch (error) {

        log(
          'Click observer error ignored',
          error
        );
      }

    },

    true
  );


  /*
   * ==================================================
   * FORM SUBMIT OBSERVER
   * ==================================================
   */

  document.addEventListener(
    'submit',

    function(event) {

      try {

        var form = null;


        if (
          event.target instanceof
            HTMLFormElement
        ) {

          form =
            event.target;
        }


        if (!form) {
          return;
        }


        var submitter = null;


        if (
          event.submitter instanceof
            Element
        ) {

          submitter =
            event.submitter;
        }


        var hasCheckoutSubmitter =
          false;


        if (submitter) {

          hasCheckoutSubmitter =
            submitter.getAttribute(
              'name'
            ) ===
            'checkout';
        }


        var isKnownCheckoutForm =
          false;


        if (
          form.id ===
            'sv-magic-checkout-form'
        ) {

          isKnownCheckoutForm =
            true;
        }


        if (
          form.id ===
            'sv-drawer-checkout-form'
        ) {

          isKnownCheckoutForm =
            true;
        }


        if (
          form.id ===
            'cart-form'
        ) {

          isKnownCheckoutForm =
            true;
        }


        if (
          !hasCheckoutSubmitter &&
          !isKnownCheckoutForm
        ) {

          return;
        }


        publishCheckoutIntent(
          getCheckoutSource(
            submitter ||
            form
          ),
          'submit'
        );


      } catch (error) {

        log(
          'Submit observer error ignored',
          error
        );
      }

    },

    true
  );


  /*
   * ==================================================
   * START
   * ==================================================
   */

  log(
    'Loaded — GA4 begin_checkout + Meta InitiateCheckout'
  );

})();